import * as React from 'react';
import { ImgAsyncSelect } from "imaginarity-react-ui"
import { ControllerHelper, UserController, UserSearchDto, UserShortInfoDownloadDto } from 'collaboration-service';
import UserTile from './UserTile';
import _ from 'lodash';

interface SelectData {
    value: string;
    label: string;
    data: UserShortInfoDownloadDto;
}
export interface UserSearchProps {
    users?: UserShortInfoDownloadDto[];    // previous value
    usersSelected?: (user: UserShortInfoDownloadDto[]) => void;
    isMulti?: boolean;
    showAvatar?: boolean;
    showEmail?: boolean;
    showPPNId?: boolean;
    darkMode?: boolean;
    toHide?: string[];
    toHideCheck?: (userId: string) => Promise<boolean>;
    searchInfo?: Partial<UserSearchDto>;
    isDisabled?: boolean;
    isClearable?: boolean;
    linkToProfile?: boolean;
    menuShouldBlockScroll?: boolean | undefined;
    maxMenuHeight?: number | undefined;
    menuShouldScrollIntoView?: boolean | undefined;
    placeholder?: string;
}

export interface UserSearchState {
    selectedUsers: UserShortInfoDownloadDto | UserShortInfoDownloadDto[];
}

// type AsyncUserSelecT = new () => ImgAsyncSelect<SelectData>;
// const AsyncUserSelect = ImgAsyncSelect as AsyncUserSelecT;

const UserSearch = (p: UserSearchProps) => {
    const { users, searchInfo, usersSelected, toHide, toHideCheck,
        showAvatar, isMulti, isDisabled, showPPNId, showEmail,
        isClearable, linkToProfile, menuShouldBlockScroll, maxMenuHeight, menuShouldScrollIntoView, placeholder } = p;
    const root = React.useMemo(() => document.getElementById("root"), []);

    const filter = React.useMemo(() => (o: any, inputValue: string) => toHide === undefined || _.findIndex(toHide, h => o.data.data.id === h) < 0, [toHide]);
    const changeOption = React.useMemo(() => (select: SelectData) => {
        //console.log("!!!!", select);
        return <UserTile
            user={select.data}
            showAvatar={showAvatar}
            showEmail={showEmail}
            showPPNId={showPPNId}
            linkToProfile={linkToProfile ?? false}
        />
    }, [showAvatar, showEmail, linkToProfile, showPPNId]);

    const userSelected = React.useMemo(() => (select?: SelectData | ReadonlyArray<SelectData>) => {
        let sel: SelectData[];
        if (select) {
            if (_.isArray(select)) {
                sel = select;   // is array
            }
            else
                sel = [select as SelectData];   // is not array

            if (usersSelected)
                usersSelected(_.map(sel, user => user.data));
        }
        else {
            if (usersSelected)
                usersSelected([]);
        }
    }, [usersSelected]);

    const mapToSelectData = React.useMemo(() => (u: UserShortInfoDownloadDto) => {
        return ({ value: u.id, label: u.firstName + " " + u.secondName, data: u });
    }, []);

    const value = React.useMemo(() => users ? _.map(users, mapToSelectData) : undefined, [users, mapToSelectData]);

    const loadOptions = React.useMemo(() => async (val: string) => {
        const res = await ControllerHelper.singleCall({ searchInfo: { ...searchInfo, general: val } }, UserController.SearchUsers, true);
        if (toHideCheck) {
            const t = _.map(res, async u => {
                const hide = await toHideCheck(u.id);
                return hide ? undefined : mapToSelectData(u);
            });
            const inenrRes = await Promise.all(t);
            return _.filter(inenrRes, r => r !== undefined) as SelectData[];
        }
        else
            return _.map(res, mapToSelectData);
    }, [mapToSelectData, toHideCheck, searchInfo]);

    return (
        <ImgAsyncSelect
            // trigger reloading on sarchInfo changes!
            key={JSON.stringify(searchInfo)}
            value={value}
            //cacheOptions
            defaultOptions
            isClearable={isClearable}
            isMulti={isMulti}
            onChange={userSelected}
            loadOptions={loadOptions}
            changeOption={changeOption}
            changeSingleValue={changeOption}
            changeMultiValue={changeOption}
            filterOption={filter}
            isDisabled={isDisabled}
            menuPortalTarget={root}
            menuShouldScrollIntoView={menuShouldScrollIntoView}
            menuShouldBlockScroll={menuShouldBlockScroll}
            maxMenuHeight={maxMenuHeight}
            placeholder={placeholder}
        />
    );
}
export default UserSearch;